class TBFeatureVideo extends HTMLElement {
  connectedCallback () {
    this.player = this.querySelector('product-video-player')
    this.controller = this.querySelector('media-controller')
    this.video = this.querySelector('video[slot="media"]')
    this.unmuteButton = this.querySelector('.feature-video__unmute')
    this.unmuted = false
    this.loadStarted = false

    if (this.unmuteButton) {
      this.unmuteButton.addEventListener('click', () => this.handleUnmute(), { once: true })
    }

    if (this.player && this.video) this.initViewportObserver()
  }

  disconnectedCallback () {
    if (this.viewportObserver) this.viewportObserver.disconnect()
  }

  initViewportObserver () {
    this.viewportObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (this.unmuted) return
        if (entry.isIntersecting) {
          this.video.muted = true
          if (!this.loadStarted) {
            this.loadStarted = true
            this.player.loadVideo()
          }
          this.player.playVideo()
        } else {
          this.player.pauseVideo()
        }
      })
    }, {
      rootMargin: '100px',
    })

    this.viewportObserver.observe(this)
  }

  handleUnmute () {
    this.unmuted = true
    if (this.viewportObserver) this.viewportObserver.disconnect()
    if (this.unmuteButton) this.unmuteButton.remove()

    if (this.player) this.player.classList.remove('feature-video__player--ambient')
    if (this.controller) this.controller.removeAttribute('gesturesdisabled')

    if (this.video) {
      this.video.loop = false
      this.video.muted = false
    }

    if (this.player) {
      this.player.loadVideo()
      this.player.playVideo()
    }
  }
}

if (!customElements.get('tb-feature-video')) {
  customElements.define('tb-feature-video', TBFeatureVideo)
}
